// import { Editor } from '@tinymce/tinymce-react';
import React, { useEffect, useRef, useState } from 'react'
import { DraftEditor } from '../tasks/_DraftEditor';
import { RenewalsModel } from '../models/RenewalsModel'
import { LeadCommentModel } from '../models/superbit-api-models'

type Props = {
    ClosePopup?: Function;
    ClosePopupAndLoad?: Function;
    leadId?: string;
};


const AddRnewalCommentPopup = (props: Props) => {


    const [topic, setTopic] = useState<any>();
    const [topicError, setTopicError] = useState<any>();

    const [text, setText] = useState<any>();
    const [textError, setTextError] = useState<any>();

    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup();
        }
    }

    const onSave = async (status?: string) => {
        const data = new LeadCommentModel();
        data.topic = topic;
        data.text = text;
        data.leadId = props.leadId;
        await new RenewalsModel().RenewalLeadCommentAdd(data);
        if (props.ClosePopupAndLoad) {
            props.ClosePopupAndLoad();
        }
    }



    useEffect(() => {


    }, []);







    return (
        <div className={`popup-wrapper add-treatment-popup add-task-popup `}>
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {'הערה'}
                        </div>
                    </div>
                    <div className="popup-body">




                        <div className="parameter-row single-item">
                            <div className={`parameter-item${topicError ? ' error' : ''}`}>
                                <div className="field">
                                    <div className="title">
                                        נושא
                                    </div>
                                    <div className="value">
                                        <input type='text' value={topic} onChange={(e: any) => setTopic(e.target.value)} />
                                    </div>
                                    {topicError && <div className='error-message'>
                                        שדה חובה
                                    </div>}
                                </div>
                            </div>

                        </div>
                        <div className='parameter-row single-item'>
                            <div className={`parameter-item`}>


                                {
                                    <DraftEditor
                                        initialHtml={text}
                                        onHtmlChange={(html: string) => setText(html)}
                                    />
                                }

                            </div>

                        </div>


                    </div>
                    <div className="popup-footer">
                        <button className="button blue pointer" onClick={(e: any) => onSave(e)}>
                            שמור
                        </button>
                        <button className="button white blue-border pointer" onClick={(e: any) => closePopup()}>
                            ביטול
                        </button>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AddRnewalCommentPopup